import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";

@Injectable()
export class CampaignTrackingService {
  private _campaignTrackerURL: string = environment.campaignTrackerUrl;

  constructor(private _http: HttpClient) {
  }

  submitCapturedData(campaignTracking: FormData): Observable<any> {
    return this._http.post(this._campaignTrackerURL, campaignTracking);
  }
}
